<template>
  <div id="news">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Message"
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#news
  width 100%
  height 100%
  overflow auto
</style>
